import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Mutation, State } from "vuex-class";

@Component({
  metaInfo() {
    const { themeColor } = this as any;
    return {
      meta: [
        {
          name: "theme-color",
          content: themeColor
        }
      ]
    };
  },
  beforeRouteEnter(_to, _from, next) {
    next((vm: any) => {
      vm.setProperties();
      vm.$store.commit("app/SET_CURRENT_PAGE_NEED_AUTH", vm.needAuth);
      vm.$store.commit(
        "app/SET_CURRENT_PAGE_NEED_FOXONE_MIGRATE",
        vm.needMigrate
      );
      vm.$store.commit(
        "app/SET_CURRENT_PAGE_NEED_MIXIN_BIND",
        vm.needMixinBind
      );
    });
  },
  beforeRouteLeave(_to, _from, next) {
    this.$store.commit("app/SET_CURRENT_PAGE_NEED_AUTH", false);
    this.$store.commit("app/SET_CURRENT_PAGE_NEED_FOXONE_MIGRATE", false);
    next();
  }
})
class PageView extends Vue {
  @Mutation("app/SET_APPBAR") setAppbar;

  @Mutation("app/SET_BOTTOM_NAV") setBottomNav;

  @Mutation("app/SET_LAYOUT") setLayout;

  @State(state => state.app.settings) settings;

  // 当前页面是否需要登录
  needAuth = true;

  // 当前页面是否需要绑定 Mixin
  needMixinBind = true;

  // 当前页面是否需要进行 FoxONE 迁移
  needMigrate = false;

  get layout() {
    return "default-layout";
  }

  get bottomNav() {
    return "";
  }

  get title() {
    return "";
  }

  get description() {
    return "";
  }

  get themeColor() {
    return this.$vuetify.theme.currentTheme.background;
  }

  get appbar() {
    return {};
  }

  setProperties() {
    this.setLayout(this.layout);

    if (this.$i18n) {
      document.title = this.$t("common.elite") + " - " + this.title;
      const locale = this.$common.utils.helper.getLocale();
      this.$i18n.locale = locale;
      this.$vuetify.lang.current = locale;
    }

    this.setAppbar({
      ...this.appbar,
      title: this.title
    });

    this.setBottomNav(this.bottomNav);

    setTimeout(() => {
      const nodes = document.querySelectorAll("[name='theme-color']");
      nodes.forEach((node: any) => {
        const content = node.content;
        if (content !== this.themeColor) {
          node.remove();
        }
      });
      this.$common.utils.helper.reloadMixinTheme();
    }, 50);
  }

  created() {
    this.setProperties();
  }
}

export default PageView;
